import { useState } from "react";
import config from "../../config";
import "./ContactForm.css";

const ContactForm = () => {
  const token = localStorage.getItem("access_token");
  const [contactForm, setContactForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState({ type: "", msg: "" });
  const [loading, setLoading] = useState(false);

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: "", msg: "" });

    try {
      const response = await fetch(`${config.REACT_APP_API_URL}/send-contact`, {
        method: "POST",
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(contactForm),
      });

      if (!response.ok) throw new Error("Failed to send message.");

      setStatus({ type: "success", msg: "Message sent successfully!" });
      setContactForm({ name: "", email: "", message: "" });
    } catch (error) {
      setStatus({ type: "error", msg: "Error sending message. Please try again." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-form-container">
      <div className="contact-header">
        <h2>Contact Support</h2>
        <p>Have a question or feedback? Send us a message.</p>
      </div>

      <form className="contact-form-body" onSubmit={handleContactSubmit}>
        <div className="form-group">
          <label htmlFor="name">Name</label>
          <input
            id="name"
            type="text"
            className="contact-input"
            value={contactForm.name}
            onChange={(e) => setContactForm({ ...contactForm, name: e.target.value })}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            className="contact-input"
            value={contactForm.email}
            onChange={(e) => setContactForm({ ...contactForm, email: e.target.value })}
          />
        </div>

        <div className="form-group">
          <label htmlFor="message">Message</label>
          <textarea
            id="message"
            className="contact-textarea"
            value={contactForm.message}
            onChange={(e) => setContactForm({ ...contactForm, message: e.target.value })}
            required
            rows={5}
          />
        </div>

        <button type="submit" className="contact-submit-btn" disabled={loading}>
          {loading ? "Sending..." : "Send Message"}
        </button>

        {status.msg && (
          <div className={`contact-status ${status.type}`}>
            {status.msg}
          </div>
        )}
      </form>

      <div className="contact-info-footer">
        <h3>Direct Contact</h3>
        <p><strong>Email:</strong> <a href="mailto:RedP@WaterviewAI.com">RedP@WaterviewAI.com</a></p>
        <p><strong>Telephone:</strong> (888) 566-5225</p>
      </div>
    </div>
  );
};

export default ContactForm;